// extracted by mini-css-extract-plugin
export default {"style":"skeleton_style__Og3Fi","load":"skeleton_load__tbp53"};